import { $fetch } from '@/boot/fetch'

const endpoint = '/users/paymentMethods'

export default {
  getAll(params = {}) {
    // params = { limit: 300, sortBy: 'purchaseExpireTime:ASC', ...params }
    return $fetch.peg(endpoint, { params })
  },
  /**
   * Add a payment method for the user
   * @param {object} body - Payment method body
   * @param {string} body.token - Payment method token (nonce) from payment gateway
   * @param {boolean} [body.isDefault=false] - Whether to set this payment
   * @param {boolean} [body.microTransferAmountsVerified] - Whether micro transfer amounts have been verified (for ACH)
   */
  add(body) {
    return $fetch.peg(endpoint, {
      method: 'POST',
      body,
    })
  },
  update(methodId, body) {
    return $fetch.peg(`${endpoint}/${methodId}`, {
      method: 'PUT',
      body,
    })
  },
  remove(methodId) {
    return $fetch.peg(`${endpoint}/${methodId}`, {
      method: 'DELETE',
    })
  },
}
